var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"customer-reviews-block"}},[_c('div',{staticClass:"content"},[_vm._m(0),_c('div',{staticClass:"separation-line"}),_c('reviews-slider',{staticClass:"slider"}),_c('div',{staticClass:"separation-line"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h6',[_vm._v("What our "),_c('br'),_vm._v(" clients say")])
}]

export { render, staticRenderFns }